import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ChangePasswordContainer} from 'components/users';
import MemberZone from './MemberZone.jsx'
import title from 'constants/TitlePages.js';

class ChangePassword extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.ChangePassword;
  }

  render() {
    return (
      <MasterLayout>
        <ChangePasswordContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(ChangePassword);



// WEBPACK FOOTER //
// ./pages/users/ChangePassword.jsx